import React from 'react';
import { Icon, Balloon } from '@alifd/next';
import PaymentIcon from '@alife/bc-icbu-icon/payments';
import * as i18n from 'src/utils/i18n';
import './index.scss';

const PAY_METHODS_MAP = {
  US: ['visa', 'mastercard', 'american-express'],
  CN: [
    'visa',
    'mastercard',
    'tt',
    'online-transfer',
    'apple-pay',
    'western-union',
    'boleto',
  ],
  MY: ['tt'],
  HK: [
    'visa',
    'mastercard',
    'tt',
    'online-transfer',
    'apple-pay',
    'western-union',
    'boleto',
  ],
  TW: [
    'visa',
    'mastercard',
    'tt',
    'online-transfer',
    'apple-pay',
    'western-union',
    'boleto',
  ],
};

const Payment = props => {
  const {
    baoAccountIsService,
    morePaymentTerms,
    companyRegisterCountry,
  } = props;
  if (!baoAccountIsService && !morePaymentTerms) {
    return null;
  }

  const TIP_MAP = {
    visa: {
      text: i18n.get('details_assurance_educate.visa'),
      link:
        '//service.alibaba.com/page/knowledge?pageId=128&category=9207651&knowledge=20111761&language=en',
    },
    mastercard: {
      text: i18n.get('details_assurance_educate.mastercard'),
      link:
        '//service.alibaba.com/page/knowledge?pageId=128&category=9207651&knowledge=20111761&language=en',
    },
    'american-express': {
      text: 'American Express',
    },
    tt: {
      text: i18n.get('details_assurance_educate.tt'),
      link:
        '//service.alibaba.com/page/knowledge?pageId=128&category=9207651&knowledge=20328873&language=en',
    },
    'online-transfer': {
      text: i18n.get('details_assurance_educate.ot'),
      link: '//activity.alibaba.com/page/4be999bb.html',
    },
    'western-union': {
      text: i18n.get('details_assurance_educate.western'),
      link:
        '//service.alibaba.com/page/knowledge?pageId=128&category=9207651&knowledge=20523911&language=en',
    },
    boleto: {
      text: i18n.get('details_assurance_educate.boleto'),
      link:
        '//service.alibaba.com/page/knowledge?pageId=128&category=9207651&knowledge=24141324&language=en',
    },
    'apple-pay': {
      text: i18n.get('details_assurance_educate.apple'),
      link: '//activity.alibaba.com/page/94418917.html',
    },
  };

  const methods = PAY_METHODS_MAP[companyRegisterCountry || 'US'] || [];

  return (
    <div className="assurance-payment">
      <span className="payment-title">
        <span className="title-text">
          {i18n.get('details_assurance_educate.text_brief_payment')}
        </span>
      </span>
      {baoAccountIsService && methods.length ? (
        <span className="payment-val">
          {methods.map(name => {
            let elItem = (
              <span className="payment-item" key={name}>
                <PaymentIcon type={name} height={12} />
              </span>
            );
            if (name === 'western-union') {
              elItem = (
                <span className="payment-item" key={name}>
                  <PaymentIcon type={name} height={12} width={100} />
                </span>
              );
            }
            if (!TIP_MAP[name]) {
              return elItem;
            }
            return (
              <Balloon
                className="payment-balloon"
                trigger={elItem}
                align="br"
                closable={false}
                key={name}
              >
                {TIP_MAP[name].text}
                {TIP_MAP[name].link ? (
                  <div className="tip-link">
                    <a
                      className="more-link"
                      href={TIP_MAP[name].link}
                      target="_blank"
                    >
                      {i18n.get('details_assurance_educate.learnmore')}
                    </a>
                  </div>
                ) : null}
              </Balloon>
            );
          })}
          {morePaymentTerms && (
            <Balloon
              trigger={
                <Icon className="icon-more" type="arrow-down" size="xs" />
              }
              align="br"
              closable={false}
            >
              {morePaymentTerms}
            </Balloon>
          )}
        </span>
      ) : (
        <span className="payment-val">{morePaymentTerms}</span>
      )}
    </div>
  );
};

export default Payment;
